// extracted by mini-css-extract-plugin
export var contentContainer = "MothersGiftInfo-module--contentContainer--8d40b";
export var fontColor = "MothersGiftInfo-module--fontColor--93d02";
export var giftInfoContainer = "MothersGiftInfo-module--giftInfoContainer--47eb6";
export var giftItem = "MothersGiftInfo-module--giftItem--1f50a";
export var giftItemsContainer = "MothersGiftInfo-module--giftItemsContainer--104cd";
export var giftTitle = "MothersGiftInfo-module--giftTitle--26477";
export var infoTitle = "MothersGiftInfo-module--infoTitle--39492";
export var sectionColor = "MothersGiftInfo-module--sectionColor--5973c";